import DashboardPage from "./dashboard";

export default DashboardPage;